import SetCurrentComponent from "@/core/services/SetCurrentComponent";

const historico_de_informacao_do_aluno = [
  {
    path: "/cadastro-de-aluno/historico-de-informacoes-do-aluno/:id",
    name: "historico_de_informacoes_do_aluno",
    meta: {
      allowedPermissions: ["historico_aluno"],
    },
    component: SetCurrentComponent(
      "CadastroDeAluno/Pages/HistoricoDeInformacoesDoAluno",
      "HistoricoDeInformacoesDoAluno"
    ),
  },
  {
    path: "/cadastro-de-aluno/historico-de-informacoes-do-aluno/:id/visualizar",
    name: "historico_de_informacoes_do_aluno_visualizar",
    meta: {
      allowedPermissions: ["historico_aluno_show"],
    },
    component: SetCurrentComponent(
      "CadastroDeAluno/Pages/HistoricoDeInformacoesDoAluno",
      "HistoricoDeInformacoesDoAlunoVisualizar"
    ),
  },
];

export { historico_de_informacao_do_aluno };
